// extracted by mini-css-extract-plugin
export default {"container":"knowledge-document-download_container__Dqh0N","marginBox":"knowledge-document-download_marginBox__oMA7B","link":"knowledge-document-download_link__wwhY6"};